import { getAuth, signOut } from "firebase/auth";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Alert, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setPageTitle } from "../../../functions";
import { GlobalContext } from "../../../store";

export const Logout: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useContext(GlobalContext);

    const [logoutState, setLogoutState] = useState<boolean>();

    const auth = getAuth();

    signOut(auth)
        .then(() => {
            // Sign-out successful.
            setLogoutState(true);
        })
        .catch((error) => {
            // An error happened.
            setLogoutState(false);
        });

    useEffect(() => {
        if (logoutState) {
            store.setLoggedUserFn(undefined);

            setTimeout(() => {
                navigate("/");
            }, 1000);
        }
        // eslint-disable-next-line
    }, [logoutState]);

    useEffect(() => {
        setPageTitle(t("Logout"));
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {logoutState ? (
                <Card>
                    <Card.Header>{t("Logout")}</Card.Header>
                    <Card.Body>
                        <Alert variant={logoutState ? "success" : "warning"}>
                            {logoutState ? (
                                t("Sign-out successful")
                            ) : (
                                <>
                                    {t(
                                        "An error happened during sign-out process"
                                    )}
                                    !
                                    <br />
                                    {t("Try again, please")}...
                                </>
                            )}
                        </Alert>
                    </Card.Body>
                </Card>
            ) : null}
        </>
    );
};
